<template>
    <div class="declined-lender-block">
        <div class="declined-pill-container">
            <div class="declined-pill">
                <span class="declined-icon"></span>
                {{ $t('results.declinedLenders.declined') }}
            </div>
        </div>

        <div class="row lender-row">
            <div class="col d-flex justify-content-center">
                <div class="lender-image-wrapper">
                    <img :src="lender.logo_url" :alt="`${lender.name} logo`" />
                </div>
            </div>
        </div>

        <div class="row lender-name w-100">
            <div class="col d-flex justify-content-center text-center ml-3">
                <div>
                    {{ lender.name }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// lodash components
import replace from 'lodash/replace'

export default {
    props: ['lender'],
    methods: {
        displayRateType: function (rateType) {
            return replace(rateType, '_', ' ')
        },
    },
    computed: {
        territory: function () {
            return process.env.TERRITORY
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/responsive';
@import '~scss/mixins/rem';

.declined-lender-block {
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.04);
    margin-top: 17px;
    padding-top: 16px;
    padding-bottom: 5px;
    min-height: 215px;
    max-height: 215px;

    .declined-pill-container {
        align-items: center;
        display: flex;
        justify-content: center;

        .declined-pill {
            align-items: center;
            border: 1px solid #eeeeee;
            border-radius: 30px;
            display: flex;
            font-size: rem(14px);
            padding: 7px 15px;

            .declined-icon {
                content: var(--url-declined);
                margin-right: 5px;
            }

            .declined-tooltip {
                content: var(--url-question-mark);
                margin-left: 5px;
            }
        }
    }

    .lender-row {
        margin-top: 21px;
        min-height: 70px;

        .col {
            .lender-image-wrapper {
                display: flex;
                justify-content: center;

                img {
                    max-height: 60px;
                    max-width: 180px;
                    object-fit: contain;
                    padding: 0 15px;
                }
            }

            .apr-percentage {
                color: var(--text-dark);
                font-size: rem(28px);
                line-height: rem(33px);
                padding-left: 15px;

                .percentage {
                    font-size: rem(16px);
                }
            }

            .apr-label {
                font-size: rem(14px);
                line-height: rem(18px);
                padding-left: 15px;
            }
        }
    }

    .lender-name {
        margin-top: 5px;
        color: #4f5157;
        font-size: rem(14px);
    }

}
</style>
